import { StatSegmentRegistry } from '@/types/stats/StatSegmentRegistry.ts';

/** Miasta poza pierwszą piątką. Jedyny KEYED w rozbiciu — reszta to LABELED. */
export enum CityBucketKey {
  OTHER = 'OTHER',
}

export const CITY_BUCKET_REGISTRY: StatSegmentRegistry = {
  [CityBucketKey.OTHER]: { label: 'Inne', tone: 'neutral' },
};
